module.exports = __webpack_public_path__ + "static/media/SCHAALKLEURSTOF_05.6e5b97a5.png";